import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { panelTypes } from '../../../../../common/panel/constants'
import { Tooltip } from '../../../../../common/tooltip'
import { selectCompanyInfo } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  DOWNLOAD_PDF,
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import { COMPANY_TYPES } from '../../../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_DOWNLOAD,
  TYPE_ITEM_SETTING,
} from '../../../constant'
import { isFs } from '../../../helper'
import { DEFAULT_INDUSTRY } from '../../../helper/companyAnalysis/industryAnalysis'
import { TitlePanelSetting } from '../TitlePanelSetting'
import { convertItemsPdf } from '../helper'
import classes from '../index.module.scss'
import {
  changeActivePanel,
  removePanel,
  resetCurrencyUnitFs,
  selectActivePanel,
  selectCurrentPortfolio,
  selectDetailPanel,
} from '../store/slice'

const getItemId = (id) => `item_${id}`

export const decodeItemId = (id) => id.split('_')[1]

let imageDragEl = null

const LayoutItem = ({ id }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const panel = useSelector(selectDetailPanel(id))
  const activePanel = useSelector(selectActivePanel)
  const companyInfo = useSelector(selectCompanyInfo)
  const currentPortfolio = useSelector(selectCurrentPortfolio)

  const isErrorIndustryAnalysis =
    companyInfo.companyType === COMPANY_TYPES.CORPORATE &&
    panel.screen === SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_ANALYSIS &&
    !panel?.setting?.[DEFAULT_INDUSTRY]

  const [isHover, setIsHover] = useState(false)

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onDragStart = (e) => {
    const dragEl = e.target.cloneNode(true)
    dragEl.style.width = panel.type === panelTypes.HALF_SIZE ? '175px' : '350px'
    dragEl.style.display = 'flex'
    imageDragEl = dragEl
    document.body.appendChild(dragEl)
    e.dataTransfer.setDragImage(dragEl, e.target.offsetWidth / 2, 20)
    e.dataTransfer.setData('childId', getItemId(id))
  }

  const onDragEnd = () => {
    if (imageDragEl) {
      document.body.removeChild(imageDragEl)
    }
    imageDragEl = null
    setIsHover(false)
  }

  const removeItem = (e) => {
    e.stopPropagation()
    if (isActive) {
      dispatch(changeActivePanel({ id: null }))
    }
    if (isFs(panel.screen)) {
      dispatch(resetCurrencyUnitFs())
    }
    dispatch(removePanel(id))
  }

  const previewPanel = (e) => {
    e.stopPropagation()
    if (
      (panel.mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS &&
        !companyInfo.organizationId) ||
      (panel.mainScreen === MAIN_SCREEN.PORTFOLIO_INSIGHT && !currentPortfolio)
    ) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        title: 'dynamicReport.TITLE_WARNING_PREVIEW',
        messages: [I18n.t('dynamicReport.CONTENT_WARNING_PREVIEW')],
      })
      return
    }
    if (isErrorIndustryAnalysis) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        title: 'common.WARNING',
        messages: [I18n.t('dynamicReport.WARNING_INDUSTRY_ANALYSIS')],
        button: 'dynamicReport.OK',
      })
      return
    }
    EventEmitter.dispatch(DOWNLOAD_PDF, {
      items: convertItemsPdf([panel.id], { [panel.id]: panel }),
      typeDownload: TYPE_DOWNLOAD.PREVIEW_SINGLE_BOX,
      localeSystem: locale,
      panel,
    })
  }

  const setActivePanel = () =>
    dispatch(changeActivePanel({ id, companyType: companyInfo.companyType }))

  const isActive = id === activePanel

  return (
    <Element
      id={getItemId(id)}
      style={{
        width: '100%',
        border: isActive ? '1px solid #2C73E8' : '1px solid #D5D5D5',
        backgroundColor: isActive ? '#C8E3FF' : isHover ? '#EDF5FE' : 'unset',
      }}
      className={classes.layoutItem}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={setActivePanel}
      draggable={true}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
    >
      <Icon
        className="icon-menu"
        style={{ color: isActive ? '#2C73E8' : '#9C9C9C', fontSize: 8 }}
      />
      <div className="flex1 ml1">
        <TitlePanelSetting label={panel.label} isShowSub={false} />
        {panel.mainScreen && (
          <span>
            {panel.mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS ? '(C)' : '(P)'}
          </span>
        )}
      </div>
      {panel.type === TYPE_ITEM_SETTING.PANEL && (
        <div>
          <Tooltip
            tooltipContent="dynamicReport.PREVIEW"
            isI18n
            contentClass="dFlex alignItemsCenter"
          >
            <Icon
              className="icon-open-new ml1"
              style={{ color: '#717ECD', fontSize: 13 }}
              onClick={previewPanel}
            />
          </Tooltip>
        </div>
      )}
      <div>
        <Tooltip tooltipContent="common.DELETE" isI18n>
          <Icon
            onClick={removeItem}
            className="icon-delete ml1"
            style={{
              color: '#9C9C9C',
              fontSize: 11,
            }}
          />
        </Tooltip>
      </div>
    </Element>
  )
}

export default LayoutItem
